/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CreateUserConflictTypes {
  EmailAlreadyInUse = 'email_already_in_use'
}
